<template lang="pug">
.main-container
  .tabs-content-wrapper()
    aiq-tabs(
      v-model="activeTab"
      @tab-click="onTabChange"
      type="border-card"
    )
      aiq-tab-pane(
        label="Intents"
        name="IQTools.Intents.Intents"
      )
        router-view(v-if="activeTab === 'IQTools.Intents.Intents'")
      aiq-tab-pane(
        v-if="showAIRecommendations"
        label="AI Recommendations"
        name="IQTools.Intents.IntentRecommendation"
      )
        router-view(v-if="activeTab === 'IQTools.Intents.IntentRecommendation'")
  building-kit-ai-testing
</template>

<script>
import { buildingKitAiTesting } from '../Partials';
import {mapState} from 'vuex';

export default {
  name: 'IntentsTabsLayout',
  components: { buildingKitAiTesting },
  computed: {
    ...mapState({
      showAIRecommendations: state => state.featureFlags.FEATURE_FLAGS.SHOW_AI_RECOMMENDATIONS,
    }),
  },
  data() {
    return {
      activeTab: this.$route.name,
    };
  },
  watch: {
    $route(to) {
      this.activeTab = to.name;
    },
  },
  methods: {
    onTabChange(tab) {
      this.$router.push({ name: tab.paneName || tab.name });
    },
  },
};
</script>

<style lang="scss" scoped>

.tabs-content-wrapper {
  flex: 1;
  min-width: 0;
  height: 100%;

  :deep(.el-tabs) {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  :deep(.el-tabs__content) {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0;
  }

  :deep(.el-tab-pane) {
    height: 100%;
    min-height: 0;
    min-width: 0;
    overflow: hidden;

    > * {
      height: 100%;
      min-height: 0;
      min-width: 0;
    }
  }
}
</style>
